<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div class="ix-table-box mb-3">
                    <table class="ix-table">
                        <tbody>
                        <tr v-for="(bonus, index) in bonuses" v-if="!loading">
                            <td>
                                {{ bonus.designation }}
                                <input type="hidden" :name="'bonuses[' + index + '][id]'" v-model="bonus.id">
                                <input type="hidden" :name="'bonuses[' + index + '][designation]'" v-model="bonus.designation">
                                <input type="hidden" :name="'bonuses[' + index + '][type]'" v-model="bonus.type">

                                <div class="input-group input-group-sm mt-2" v-show="(bonus.type == 2 || bonus.type == 3) && fillDetails">
                                    <input :type="bonus.type == 2 ? 'time' : 'number'" :name="'bonuses[' + index + '][details]'" class="form-control form-control-sm" v-model="bonus.details" :required="(bonus.type == 2 || bonus.type == 3) && fillDetails && detailsRequired">
                                    <div class="input-group-append" v-if="bonus.type == 3">
                                        <span class="input-group-text">km</span>
                                    </div>
                                </div>

                            </td>
                            <td class="text-right">
                                <button type="button" class="btn btn-sm transparent" @click="deleteRow(index)">
                                    <i class="far fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                        <tr v-if="loading">
                            <td colspan="2" class="text-center">
                                <i class="far fa-circle-notch fa-spin"></i>
                            </td>
                        </tr>
                        <tr v-show="!loading">
                            <td colspan="2">
                                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control" id="bonusSearchInput" type="text" v-model="bonus">
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";

    export default {
        name: 'bonus-seletor',
        props: ['route', 'oldBonuses', 'exclude', 'fillDetails', 'detailsRequired'],
        data() {
            return {
                loading: true,
                bonus: null,
                bonuses: []
            };
        },
        methods : {
            addRow: function (bonus) {
                if (this.getCurrentSelectedBonusesId().includes(bonus.id) == false && (this.exclude == undefined || (this.exclude != undefined && this.exclude != bonus.id))) {
                    this.bonuses.push({
                        id: bonus.id,
                        designation: bonus.designation,
                        type: bonus.type,
                        details: bonus.details
                    })
                }
            },
            deleteRow: function (index) {
                this.bonuses.splice(index, 1)
            },
            getCurrentSelectedBonusesId: function() {
                return this.bonuses.map(bonus => bonus.id);
            }
        },
        mounted(){
            $("#bonusSearchInput").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url : this.route,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, '!id': this.getCurrentSelectedBonusesId().join(';') + (this.exclude != undefined ? (';' + this.exclude) : '') },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation
                                })
                            }))
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        var subcontent = item.conditions ? `<span class="ui-autocomplete-subcontent">(${item.conditions})</span>` : ''

                        var html = `<div class="d-flex align-items-center">
                                      <span>${item.designation} ${subcontent}</span>
                                    </div>`;

                        if (item.bonuses.length > 0) {
                            html = `<div class="d-flex align-items-center">
                                        <i class="far fa-folder"></i>
                                        <span class="ml-1">${item.designation} ${subcontent}</span>
                                    </div>`;
                        }


                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                change: (e, item) => {
                    if(!item.item){
                        $(e.target).val("");
                        this.bonus = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        if (item.item.bonuses.length > 0) {
                            item.item.bonuses.forEach(bonus => {
                                this.addRow(bonus)
                            })
                        } else {
                            this.addRow(item.item)
                        }

                        $(e.target).val("")
                        this.bonus = null
                    }
                }
            }).focus(() => {
                $("#bonusSearchInput").autocomplete("search", '');
            });

            const jsonBonusBackup = JSON.parse(this.oldBonuses)
            if (Array.isArray(jsonBonusBackup)) {
                if (jsonBonusBackup.length > 0) {
                    jsonBonusBackup.forEach(bonus => {
                        this.addRow(bonus)
                    })
                }
            }
            this.loading = false
        }
    }
</script>
